import { createContext } from 'react';

export type RequestPushNotificationsContextProps = {};

export const RequestPushNotificationsContext =
  createContext<RequestPushNotificationsContextProps>({});
